<template>
  <v-dialog v-model="opened" max-width="1000" persistent>
    <v-card>
      <v-card-title class="headline">
        Manajemen Jadwal Kelas
        <v-btn icon @click="close()" class="ml-auto">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-tabs v-model="tab" background-color="transparent" grow>
        <v-tab>Jadwal Kelas</v-tab>
        <v-tab v-if="id">List Member</v-tab>
      </v-tabs>


      <v-tabs-items v-model="tab">
        <v-tab-item>
          <form-jadwal ref="formJadwal"
          :id="id" @success="onSuccess('jadwal')" />
        </v-tab-item>
        <v-tab-item v-if="id">
          <list-booking :id="id" @success="onSuccess('booking')" />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-dialog>
</template>

<script>
import FormJadwal from "./FormJadwal.vue";
import ListBooking from "./ListBooking.vue";

export default {
  components: { FormJadwal, ListBooking },
  data() {
    return {
      opened: false,
      id: null,
      tab: 0,
    };
  },
  methods: {
    open(id) {
  this.id = id || null;
  this.opened = true;
  this.tab = 0;

  this.$nextTick(() => {
    if (id && this.$refs.formJadwal?.getData) {
      this.$refs.formJadwal.getData(id); // langsung load
    } else if (!id && this.$refs.formJadwal?.resetForm) {
      this.$refs.formJadwal.resetForm(); // tambah baru
    }
  });
},
    close() {
  this.opened = false;

  // tambahkan ini supaya id selalu dianggap fresh
  this.$nextTick(() => {
    this.id = null;
  });

  this.step = 0;
  if (this.$refs.form?.reset) {
    this.$refs.form.reset();
  }
},
    onSuccess(source) {
      this.$emit("success");
      this.$swal.fire({
        icon: "success",
        title: "Berhasil",
        text: `Data ${source} berhasil disimpan`,
        timer: 3000,
        showConfirmButton: false,
      });
      this.close();
    },
  },
};
</script>
